import Repository from './Repository';

export default class BoardListRepository extends Repository {
    protected basePath = 'boards/lists';

    protected messages = {
        destroy: this.__('List successfully deleted.'),
        reorder: this.__('List order changed successfully.'),
        store: this.__('List successfully created.'),
        update: this.__('List successfully updated.'),
    }

    protected redirects = {}

    public export(params: object = null): Promise {
        console.error('Export method does not exist on BoardListRepository.');
    }

    public import(data: object): Promise {
        console.error('Import method does not exist on BoardListRepository.');
    }

    public reorder(data: object) {
        if (!this.basePath) {
            console.error('Request: no basePath defined.');

            return;
        }

        return new Promise((resolve, reject) => {
            this.request.post(this.buildPath(this.basePath + '/reorder'), data)
                .then((response : any) => {
                    this.request.message = this.messages.reorder;
                    this.request.status = 200;
                    this.request.title = this.__('Success');

                    resolve(response.data);
                })
                .catch(error => reject(error));
        });
    }

    public show(id: string, params: object = null): Promise {
        console.error('Show method does not exist on BoardListRepository.');
    }
}